import React, {Component} from 'react';
import GlobalVariable from '../../GlobalVariable';
import api from '../../api';
import Menu from '../Menu';
import PageHeader from '../PageHeader';
import './HrFeedback.scss';

const TOPICS = [
    {value: 'workplace_equipment', label: 'Оборудование рабочего места'},
    {value: 'relationships', label: 'Взаимоотношения'},
    {value: 'salary', label: 'Оплата труда'},
];

class HrFeedback extends Component<any, any> {
    constructor(props: any) {
        super(props);
        window.scrollTo(0, 0);
        this.state = {
            topic: TOPICS[0].value,
            text: '',
            mood: '',
            isSubmitting: false,
            success: '',
            error: '',
        };
    }

    getStoredCompany = () => {
        try {
            const raw = sessionStorage.getItem('companyActive');
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    };

    submit = () => {
        if (!this.state.text.trim()) {
            this.setState({error: 'Напишите сообщение'});
            return;
        }

        const company = this.getStoredCompany();
        this.setState({isSubmitting: true, error: '', success: ''});
        api({
            url: GlobalVariable.supportBack() + '/api/staff/hr-feedback',
            method: 'POST',
            withCredentials: true,
            headers: {'Content-Type': 'application/json'},
            data: {
                topic: this.state.topic,
                text: this.state.text,
                mood: this.state.mood,
                companyId: company?.id || company?.companyId || '',
                salon: [company?.city, company?.address].filter(Boolean).join(', '),
                staffName: company?.nameClient || '',
            },
        }).then(() => {
            this.setState({
                isSubmitting: false,
                text: '',
                mood: '',
                success: 'Заявка отправлена',
            });
        }).catch((error) => {
            if (error?.response?.status === 401) {
                window.location.href = '/start';
                return;
            }
            this.setState({isSubmitting: false, error: 'Не удалось отправить заявку'});
        });
    };

    renderMoodButton(value: string, label: string) {
        const active = this.state.mood === value;
        return (
            <button
                type='button'
                onClick={() => this.setState({mood: value})}
                className={`hr-feedback-mood-button ${active ? 'is-active' : ''}`}
            >
                {label}
            </button>
        );
    }

    render() {
        return (
            <div className='main hr-feedback'>
                <div className='content mx-w-content'>
                    <PageHeader pageTitle='HR' backBtnUrl='/'/>
                    <div className='pt-header'></div>

                    <div className='hr-feedback-card'>
                        <div className='hr-feedback-head'>
                            <div>
                                <div className='hr-feedback-kicker'>HR</div>
                                <h2 className='hr-feedback-title'>Обратная связь</h2>
                            </div>
                            <span className='hr-feedback-status'>Для HR</span>
                        </div>

                        <label className='hr-feedback-field'>
                            <span className='hr-feedback-label'>Тема</span>
                            <span className='hr-feedback-select-wrap'>
                                <select
                                    className='hr-feedback-input'
                                    value={this.state.topic}
                                    onChange={(event) => this.setState({topic: event.target.value})}
                                >
                                    {TOPICS.map((topic) => (
                                        <option key={topic.value} value={topic.value}>{topic.label}</option>
                                    ))}
                                </select>
                            </span>
                        </label>

                        <div className='hr-feedback-field'>
                            <div className='hr-feedback-label'>Как дела?</div>
                            <div className='hr-feedback-mood-grid'>
                                {this.renderMoodButton('happy', 'Хорошо')}
                                {this.renderMoodButton('neutral', 'Нормально')}
                                {this.renderMoodButton('sad', 'Плохо')}
                            </div>
                        </div>

                        <label className='hr-feedback-field'>
                            <span className='hr-feedback-label'>Сообщение</span>
                            <textarea
                                className='hr-feedback-input hr-feedback-textarea'
                                value={this.state.text}
                                onChange={(event) => this.setState({text: event.target.value})}
                                placeholder='Напишите, что важно передать HR'
                            />
                        </label>

                        {this.state.error ? <div className='hr-feedback-message is-error'>{this.state.error}</div> : null}
                        {this.state.success ? <div className='hr-feedback-message is-success'>{this.state.success}</div> : null}

                        <button
                            type='button'
                            onClick={this.submit}
                            disabled={this.state.isSubmitting}
                            className='hr-feedback-submit'
                        >
                            {this.state.isSubmitting ? 'Отправляем...' : 'Отправить'}
                        </button>
                    </div>
                </div>
                <Menu/>
            </div>
        );
    }
}

export default HrFeedback;
